// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "caption-text-module--base-text-alt--global--c4033";
export var baseTextGlobal = "caption-text-module--base-text--global--906ab";
export var blockSpacing100 = "caption-text-module--block-spacing-100--9fed0";
export var blockSpacing50 = "caption-text-module--block-spacing-50--0ae05";
export var blockVPadding100 = "caption-text-module--block-v-padding-100--706ab";
export var blockVPadding50 = "caption-text-module--block-v-padding-50--597d4";
export var caption = "caption-text-module--caption--b383a";
export var captionTextGlobal = "caption-text-module--caption-text--global--4e594";
export var cmsRenderedContentGlobal = "caption-text-module--cms-rendered-content--global--ca234";
export var defaultHSpacingGlobal = "caption-text-module--default-h-spacing--global--a8561";
export var fadeInAnimation = "caption-text-module--fadeInAnimation--d88e2";
export var fadeInOnLoadGlobal = "caption-text-module--fade-in-on-load--global--b2f25";
export var fullHeightGlobal = "caption-text-module--full-height--global--a070c";
export var fullHeightOmittingNavGlobal = "caption-text-module--full-height-omitting-nav--global--78273";
export var headingTextGlobal = "caption-text-module--heading-text--global--89329";
export var ingressTextGlobal = "caption-text-module--ingress-text--global--d4479";
export var linkColorChangeTransitionGlobal = "caption-text-module--link-color-change-transition--global--820ce";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "caption-text-module--page-heading-text--global--224c1";
export var paragraphTextGlobal = "caption-text-module--paragraph-text--global--10886";
export var subheadingTextGlobal = "caption-text-module--subheading-text--global--6ec12";